import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';


export default function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
       <Link color="inherit" href="https://wa.me/message/HR336Z25T5EHG1">
         
        Suporte Via Whatsapp. 
        <WhatsAppIcon/>
        </Link>
        <br></br>
        
        {'Copyright © '}
        <Link color="inherit" href="">
          Ibinar
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      
    );
  }